<script setup>
  import { ref } from "vue";
  import { storeToRefs } from "pinia";
  import TwoPanePage from "@templates/TwoPanePage.vue";
  import TargetsList from "@/components/Admin/Pricer/ProjectTargets/List.vue";
  import TargetForm from "@/components/Admin/Pricer/ProjectTargets/Form.vue";
  import SimilarProjects from "@/components/Admin/Pricer/ProjectTargets/SimilarProjects.vue";
  import { Card } from "@/components/ui/card";
  import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
  import { Target, History } from "lucide-vue-next";
  import { usePricerProjectStore } from "@stores/pricer/pricerProject";

  const projectStore = usePricerProjectStore();
  const { selectedTarget } = storeToRefs(projectStore);

  const activeTab = ref("cpi");
</script>

<template>
  <TwoPanePage>
    <template #left>
      <TargetsList />
    </template>
    <template #right>
      <Card
        v-if="selectedTarget"
        class="p-6">
        <Tabs
          v-model="activeTab"
          class="w-full gap-4">
          <div class="flex items-center justify-between gap-4">
            <h2 class="heading-title truncate">{{ selectedTarget.name || "Target" }}</h2>
            <TabsList>
              <TabsTrigger
                value="cpi"
                class="gap-1.5 px-3">
                <Target />
                CPI
              </TabsTrigger>
              <TabsTrigger
                value="histo"
                class="gap-1.5 px-3">
                <History />
                Histo
              </TabsTrigger>
            </TabsList>
          </div>
          <TabsContent
            class="mt-0"
            value="cpi">
            <TargetForm />
          </TabsContent>
          <TabsContent
            class="mt-0"
            value="histo">
            <SimilarProjects />
          </TabsContent>
        </Tabs>
      </Card>
    </template>
  </TwoPanePage>
</template>
